const normal = "machine-list-view-normal"
const running = "machine-list-view-running"
const processing = "machine-list-view-processing"
const error = "machine-list-view-error"

// Machine status
export const MACHINE_STATUS = {
    ERROR: 1,
    RUNNING: 2,
    OFF: 3,
    SAVED: 6,
    OFF_FOR_CLONE: 8,
    STARTING: 10,
    RESET: 11,
    RESTARTING: 12,
    PROCESSING: 13,
    CREATING: 32773
}

// Machine list style
export const MACHINE_LIST_STYLE = {
    "1": error,
    "2": running,
    "3": normal,
    "6": normal,
    "8": normal,
    "10": processing,
    "11": processing,
    "12": processing,
    "13": normal,
    "32773": processing,
}

// Machine status text
export const MACHINE_STATUS_TEXT = {
    "1": "Error",
    "2": "Running",
    "3": "Off",
    "6": "New",
    "8": "Shutting down (Clone)",
    "10": "Starting",
    "13": "Processing",
    "32773": "Creating",
}

// Machine status text color
export const MACHINE_STATUS_COLOR = {
    "1": "red",
    "2": "forestgreen",
    "3": "red",
    "6": "dodgerblue",
    "8": "darkorange",
    "10": "rebeccapurple",
    "13": "darkorange",
    "32773": "darkorange",
}

// Style status text
export const MACHINE_STATUS_STYLE_TEXT = {
    "1": "status-text-error",
    "2": "status-text-running",
    "3": "status-text-off",
    "6": "status-text-new",
    "8": "status-text-processing",
    "10": "status-text-processing",
    "13": "status-text-processing",
    "32773": "status-text-processing",
}

// Style status text
export const MACHINE_STATUS_ICON = {
    "1": "el-icon-close",
    "2": "el-icon-loading",
    "3": "el-icon-switch-button",
    "6": "el-icon-check",
    "8": "el-icon-time",
    "10": "el-icon-loading",
    "13": "el-icon-time",
    "32773": "el-icon-loading",
}

// Machine status dot color
export const MACHINE_STATUS_DOT_COLOR = {
    "1": "#E0E0E0",
    "2": "#66BB6A",
    "3": "#E0E0E0",
    "6": "#42A5F5",
    "8": "darkorange",
    "10": "darkorange",
    "13": "darkorange",
    "32773": "rebeccapurple",
}

// Rent type
export const RENT_TYPE = {
    NO_FIXED: 1,
    FIXED_RENTAL: 2,
};

//Service type
export const SERVICE_TYPE = {
    ALL: 0,
    GPUHUB: 1,
    REMOTE_FARM: 2,
    CPUHUB: 3,
}

// Shutdown type
export const SHUTDOWN_TYPE = {
    SHUTDOWN_NORMAL: 1,
    SHUTDOWN_TO_CLONE: 2,
}

// Package type
export const PACKAGE_TYPE = {
    SINGLE: 0,
    MULTI1: 1,
    MULTI2: 2,
}

// Create image status
export const CREATE_IMAGE_STATUS = {
    SUCCESS: 1,
    LIMITED_IMAGE: 2,
}

// Boot machine status
export const BOOT_MACHINE_STATUS = {
    SUCCESS: 1,
    FIXED_RENTAL_TOO_EARLY: 2,
    FIXED_RENTAL_EXPIRED: 3,
    BALANCE_NOT_ENOUGH: 4,
    TOTAL_RECHARGE_NOT_ENOUGH: 5,
    MACHINE_NOT_AVAILABLE: 6,
    MAC_USED: 7,
}

// Clone image status
export const CLONE_IMAGE_STATUS = {
    SUCCESS: 1,
    BALANCE_NOT_ENOUGH: 2,
    NO_DEPOSIT: 3,
    LIMITED_IMAGE: 4,
    MAXIMUM_PER_REQUEST: 5,
}

// Clone image status
export const SCHEDULER_SHUTDOWN_RESULT = {
    SUCCESS: 1,
    DATE_FORMAT: 2,
    DATE_VALID: 3,
    INVALID_STATE: 4,
    INVALID_TIME_FIXED_RENTAL: 5,
}

// Rental request type
export const RENTAL_REQUEST_TYPE = {
    NOTIFY_MACHINE_AVAILABLE: 1,
    FIXED_RENTAL_REQUEST: 2,
};

//Machine list filter by
export const MACHINE_LIST_FILTER_BY = {
    ALL: 1,
    FIXED_RENTAL: 2,
    NOT_FIXED_RENTAL: 3,
}

//Operating system
export const OPERATING_SYSTEM = {
    WINDOWS: 1,
    UBUNTU: 2,
}

export const CATEGORY_ID = {
    SOFTWARE_3D: 1,
    AI: 2,
    VIDEO_EDITER: 3,
}

export const CONNECT_TO_IMAGE_TAB = {
    REMOTE_DESKTOP: "REMOTE_DESKTOP",
    SSH: "SSH",
    PARSEC_PRIME: "PARSEC_PRIME",
    OTHER_SOFTWARE: "OTHER_SOFTWARE",
}